import React, { Fragment } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { localizeCurrencyToWholeNumber } from "src/utils";
import { AccountState } from "Types/state";
import { NullablePrice } from "Types/api/NullablePrice";
import { getAccountDisclaimer } from "src/store/selectors/accountDisclaimers";

export interface MsrpProps {
    account: AccountState;
    msrp?: number;
    price?: NullablePrice;
    canShowMsrp: boolean;
    showStrikethroughForMsrp: boolean;
}

const TextLight = styled("span")`
    color: ${(props) => props.theme.palette.grey[20]};
    font-size: 13px;
    font-weight: normal;
`;

const Text = styled("span")`
    display: block;
    font-size: 14px;
    font-weight: normal;
    margin-top: 8px;
`;

export const MSRPWithPrice = styled(TextLight)<{ showStrikethrough: boolean }>`
    text-decoration: ${(props) => (props.showStrikethrough ? "line-through" : "none")};
`;

const Msrp: React.FunctionComponent<MsrpProps & WithTranslation> = ({
    account,
    msrp,
    price,
    canShowMsrp,
    showStrikethroughForMsrp,
    t,
}) => {
    const basePrice = `${account.account_disclaimers.base_price.toUpperCase()}: `;
    let priceNode;

    if (msrp && canShowMsrp) {
        if (msrp === price) {
            priceNode = (
                <Text>
                    {getAccountDisclaimer({ account }, "msrp", "MyGarage.TableCompare.msrpLabel")}
                    {localizeCurrencyToWholeNumber(msrp)}
                </Text>
            );
        } else {
            priceNode = (
                <Fragment>
                    <MSRPWithPrice showStrikethrough={showStrikethroughForMsrp}>
                        {getAccountDisclaimer({ account }, "msrp", "MyGarage.TableCompare.msrpLabel")}
                        {localizeCurrencyToWholeNumber(msrp)}
                    </MSRPWithPrice>
                    <br />
                    <strong>{basePrice}</strong>
                    {localizeCurrencyToWholeNumber(price)}
                </Fragment>
            );
        }
    } else {
        priceNode = (
            <Fragment>
                <strong>{basePrice}</strong>
                {localizeCurrencyToWholeNumber(price)}
            </Fragment>
        );
    }

    return <Text>{priceNode}</Text>;
};

export default withTranslation()(Msrp);
